"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _actionType = require("../actionType");

var _actions = require("../actions");

var _config = _interopRequireDefault(require("./config"));

var _marked =
/*#__PURE__*/
_regenerator.default.mark(fetchAuthUser),
    _marked2 =
/*#__PURE__*/
_regenerator.default.mark(_callee);

function fetchAuthUser() {
  var user;
  return _regenerator.default.wrap(function fetchAuthUser$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return _config.default.remoteGetAuthUser();

        case 3:
          user = _context.sent;
          _context.next = 6;
          return (0, _effects.put)((0, _actions.fetchAuthUserSuccess)(user));

        case 6:
          _context.next = 13;
          break;

        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _context.next = 12;
          return (0, _effects.put)((0, _actions.fetchAuthUserFailure)(_context.t0));

        case 12:
          throw _context.t0;

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 8]]);
}

function _callee() {
  return _regenerator.default.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 7;
            break;
          }

          _context2.next = 3;
          return (0, _effects.take)(_actionType.FETCH_AUTH_USER_REQUEST);

        case 3:
          _context2.next = 5;
          return fetchAuthUser();

        case 5:
          _context2.next = 0;
          break;

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this);
}